module.exports = __webpack_public_path__ + "static/media/vimlogo.312eb66a.svg";